

























































import { Component, Prop } from 'vue-property-decorator'
import Vue from 'vue'
import Field, { Option } from '@/dto/deliveries/Field'
import Delivery from '@/dto/deliveries/Delivery'
import { Errors } from '@/dto/ErrorsResponse'

@Component
export default class DynamicFields extends Vue {
  @Prop(Array)
  fields: Field[]

  @Prop(Object)
  model: Delivery

  @Prop(Object)
  errors: Errors

  fieldTypes = {
    text: 'text',
    number: 'number',
    select: 'select',
    checkbox: 'checkbox',
    radio: 'radio',
    toggle: 'toggle',
  }

  getInputError(fieldName: string) {
    return this.errors[fieldName] || ''
  }

  hasInputError(fieldName: string) {
    return fieldName in this.errors
  }
}
